import { union } from 'io-ts/Decoder';

import { Area } from '../../ui/geometry/Area';
import { Line } from '../../ui/geometry/Line';

export const ScalePath = union(Line, Area);
